// euclidean.js

// Function to generate Euclidean rhythm
export const generator = (n, b, call=false) => {
    if (n <= 0) return [];
    if (b <= 0) return Array(n).fill(0); // no hits → n rests (was [0])
    if (b > n) b = n;                    // more hits than steps → all hits (was [0])
  
    let front = Array.from({ length: b }, () => 1); // Array of `b` elements filled with 1
    let back = Array.from({ length: n - b }, () => 0); // Array of `n - b` elements filled with 0
  
    front = euclidRecursive(front, back).flat(Infinity); // flat(20) left nested arrays for n >= 22
  
    function euclidRecursive(front, back) {
      if (back.length < 1) {
        return [...front, ...back];
      }
  
      let newArray = [];
  
      while (front.length > 0 && back.length > 0) {
        newArray.push([front.pop(), back.pop()]);
      }
      return euclidRecursive(newArray, [...front, ...back]);
    }
    if(call){
      const response = front.map(value => value + 5);
      return [].concat(front, response);

    }
    return front; // Return the final computed array
  };
  
  // Rotate Array for Necklace
  // Rotate right by `steps` (negative = left). Returns a NEW array; input untouched.
  export const rotatearray = (array, steps) => {
    const n = array.length;
    if (n === 0) return [];
    const k = ((steps % n) + n) % n;
    return [...array.slice(n - k), ...array.slice(0, n - k)];
  };


  export const Alphacode = (array, sequence) => {
    let j = 0;
    const resultArray = [...array]; // Create a copy of the input array
  
    if (!Array.isArray(sequence)) {
      console.error('Sequence is not an array:', sequence);
      return resultArray; // Return the original array if sequence is not an array
    }
  
    for (let i = 0; i < resultArray.length; i++) {
      if (resultArray[i] === 1) {
        if (j < sequence.length) {
          resultArray[i] = sequence[j];
          j++;
        } else {
          break;
        }
      }
    }
  
    return resultArray;
  };
  
  